import { useFlags } from '@atlaskit/flag/use-flags';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { Box } from '@atlaskit/primitives/box';
import { useEffect, useId } from 'react';
import { useIntl } from 'react-intl';

import messages from './messages';

export const DefaultFallback = () => {
	const { formatMessage } = useIntl();
	return (
		<Box testId="error-boundary-default-fallback">{formatMessage(messages.defaultFallback)}</Box>
	);
};

export const FlagFallback = () => {
	const { showFlag } = useFlags();
	const { formatMessage } = useIntl();
	const flagId = useId();

	useEffect(() => {
		showFlag({
			id: flagId,
			testId: 'error-boundary-flag-fallback',
			icon: <StatusErrorIcon label={formatMessage(messages.flagIconLabel)} />,
			title: formatMessage(messages.flagTitle),
			description: formatMessage(messages.flagDescription),
			appearance: 'error',
			actions: [
				{
					content: formatMessage(messages.flagReloadButton),
					onClick: () => window.location.reload(),
				},
			],
		});
	}, [showFlag, flagId, formatMessage]);

	return null;
};
